var React = require('react');

function IconHi (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M265.7 421.371V172.324H140.677v624.118H265.7V546.395h250.047v250.047H640.77V172.324H515.747v249.047H265.7zm500.094 0h125.023v375.07H765.794v-375.07zm0-187.535h125.023v125.023H765.794V233.836z"}));
}

IconHi.displayName = "IconHi";

IconHi.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconHi;

IconHi.default = IconHi;
